import React from "react"
import ContentLoader from 'react-content-loader'

export const SkeletonLine = (props) => (
  <ContentLoader 
    speed={1}
    width={"100%"}
    height={"100%"}
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect width="100%" height="100%"  /> 
  </ContentLoader>
)

